export default __webpack_public_path__ + "static/assets/med_pill_round_out_L2_solid_l_01_f_mask.d047580f.png";